import dayjs from 'utils/dayjs';
import {
  DEFAULT_API_DATE_FORMAT,
  DEFAULT_MOBILE_DATE_FORMAT,
  parseDate,
  request,
} from 'utils';

import {
  FETCH_CARDS_RATES_REQUEST,
  FETCH_CARDS_RATES_SUCCESS,
  FETCH_CARDS_RATES_FAILURE,
} from 'actionTypes';
import { currencies } from 'constants/currency';

export const fetchCardsRates = params => async dispatch => {
  const currencyList = Object.values(currencies).join(',');

  const { date = null, currency = null } = params;

  const requestCurrency = `base=UAH&list=${currency || currencyList}`;

  dispatch({
    type: FETCH_CARDS_RATES_REQUEST,
    payload: {
      dateKey: date || dayjs().format(DEFAULT_MOBILE_DATE_FORMAT),
    },
  });

  try {
    const [allCardsData, visaData, mcData] = await Promise.all([
      request({
        url: `${process.env.APP_MINFIN_API_DOMAIN}/api/currency/cards?${requestCurrency}`,
        params: {
          ...(date
            ? { date: parseDate(date)?.format(DEFAULT_API_DATE_FORMAT) }
            : {}),
        },
      }),
      request({
        url: `${process.env.APP_MINFIN_API_DOMAIN}/api/currency/visa?${requestCurrency}`,
      }),
      request({
        url: `${process.env.APP_MINFIN_API_DOMAIN}/api/currency/mc?${requestCurrency}`,
      }),
    ]);

    const entities = {
      all: allCardsData.data,
      visa: visaData.data,
      mc: mcData.data,
    };

    return dispatch({
      type: FETCH_CARDS_RATES_SUCCESS,
      payload: {
        dateKey: date || dayjs().format(DEFAULT_MOBILE_DATE_FORMAT),
        entities,
      },
    });
  } catch (error) {
    return dispatch({
      type: FETCH_CARDS_RATES_FAILURE,
      payload: {
        dateKey: date || dayjs().format(DEFAULT_MOBILE_DATE_FORMAT),
      },
    });
  }
};
